function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42a5f5"
    },
    d: "m4 13 9-9 31 31-9 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1565c0"
    },
    d: "m16.176 16.18-1.414-1.414 4.5-4.5 1.414 1.414Zm17.148 8.144 1.414 1.414-2.5 2.5-1.414-1.414ZM16.293 7.293l1.414 1.414-2.5 2.5-1.414-1.414Zm23.059 23.059 1.418 1.414-2.504 2.5-1.414-1.414ZM22.293 13.293l1.414 1.414-2.5 2.5-1.414-1.414Zm9.531 18.531 4.5-4.5 1.414 1.414-4.5 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e57373"
    },
    d: "m42.582 9.066-3.648-3.648a1.422 1.422 0 0 0-2.016 0l-1.719 1.719 5.664 5.664 1.719-1.719a1.422 1.422 0 0 0 0-2.016"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9800"
    },
    d: "M6.906 35.426 32.367 9.965l5.664 5.668-25.46 25.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5"
    },
    d: "m40.863 12.8-2.832 2.833-5.668-5.66 2.832-2.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffc107"
    },
    d: "M6.906 35.43 5 43l7.57-1.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f"
    },
    d: "M5.965 39.172 5 43l3.828-.965Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.128c7eee96123a585c53694d3c9e4e7a.svg";
export { ForwardRef as ReactComponent };